// @ts-check

import { createEntry, updateEntry } from '@/api/entries'
import AlreadyApprovedErrorDialog from '@/components/entryEdit/AlreadyApprovedErrorDialog.vue'
import { useDialog } from '@/core/composables/useDialog'
import { isAxiosError } from 'axios'
import invariant from 'invariant'
import { serialize } from './utils'

/**
 * Creates an assignment entry.
 * @param {EntryActionContext} context
 * @param {*} payload
 */
const postEntry = async ({ commit, state }, payload) => {
  invariant(state.type, 'Entry type missing')

  const entry = await createEntry(state.type, payload)
  commit('setEntryId', entry.id)
  commit('setEntryData', entry)
  return entry
}

/**
 * Updates an assignment entry.
 * @param {EntryActionContext} context
 */
export const patchEntry = async ({ commit, state, getters }) => {
  invariant(state.id, 'Entry id missing')
  invariant(state.type, 'Entry type missing')

  try {
    const entry = await updateEntry(state.type, state.id, serialize(getters))
    commit('setEntryId', entry.id)
    commit('setEntryData', entry)
    return entry
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.data?.error?.error === 'already_approved'
    ) {
      useDialog().showDialog({ component: AlreadyApprovedErrorDialog })
    }

    throw error
  }
}

/** @type {EntryActionTree} */
export const assignmentActions = {
  postEntry,
  patchEntry
}

export default assignmentActions
